<template>
  <div class="head">
    <div class="head_logo"><img src="../../../static/images/logo.png" alt=""></div>
    <div class="head_menu" @click="_translat()"><img src="../../../static/images/hamburger.png" alt=""></div>
    <span><a v-link="{path:'/home'}">{{index}}</a></span>
    <span><a v-link="{path:'/fashion'}">{{fashion}}</a></span>
    <span><a v-link="{path:'/walkin'}">{{into}}</a></span>
    <!--<span><a v-link="{path:'/vip'}">{{club}}</a></span>-->
    <span><a href="http://vip.koradior.cn/#/">{{club}}</a></span>
    <span><a v-link="{path:'/stores'}">{{stores}}</a></span>
  </div>
  <div :class=" top.onoff ? 'show' : '' "  class="hamburgermenu">
    <ul>
      <li><a v-link="{path:'/home'}">{{index}}</a></li>
      <li><a v-link="{path:'/fashion'}">{{fashion}}</a></li>
      <li><a v-link="{path:'/walkin'}">{{into}}</a></li>
      <li><a href="http://vip.koradior.cn/#/">{{club}}</a></li>
      <!--<li><a v-link="{path:'/vip'}">{{club}}</a></li>-->
      <li><a v-link="{path:'/stores'}">{{stores}}</a></li>
    </ul>
  </div>
  <div class="overlay" :class=" right.onoff ? 'showright' : '' " @click="_transwidth"></div>
</template>


<script>
  export default{
    components: {
    },
//    mixins:[vtips],
      data () {
        return{
          title:"NAERSI",
          index:"首页",
          fashion:"时装",
          into:"走进NAERSI",
          club:"VIP俱乐部",
          stores:"品牌门店",
          top:{
            "onoff":false
          },
          right:{
            "onoff":false
          }
        }
      },
     methods:{
       _translat:function () {
           this.top.onoff = true;
           this.right.onoff = true;
           console.log(1111,this.top.onoff)
           console.log(1111,this.right.onoff)
       },
       _transwidth:function () {
         this.top.onoff = false;
         this.right.onoff = false;
       }
     }
  }
</script>

<style>
  .head{font-size: 0.16rem;width: 9rem;margin: 0 auto;text-align: center }
  .head_logo{margin: 0.5rem auto}
  .head span + span{margin-left: 0.5rem}
  .head span a{color: #000000;text-decoration: none }
  @media screen and (min-width: 30em){
    .head_menu{display: none}
    .hamburgermenu{display: none}
  }
  @media screen and (max-width: 30em) and (min-width:20em ){
    .head{width: 100%;height: 0.4rem;position: relative;}
    .head span{display: none}
    .head_logo{float: left;margin-left: 0.2rem;max-width: 21.1111111%}
    .head_logo img{float: left;margin-left: 0.2rem;width: 100%;height: 100%}
    .head_menu{display: block;float: right;margin-right: 0.2rem;margin-top: 10%;max-width: 8%}
    .head_menu img{width: 100%;height:100%;display: block;}
    .hamburgermenu{-webkit-transform: translate3d(-110%, 0, 0);transform: translate3d(-110%, 0, 0);-webkit-transition:transform 0.3s;transition:transform 0.3s;height: 100%;width: 1.5rem;background: #000;position: fixed;top: 0;left: 0;z-index: 101;overflow: hidden; -webkit-box-shadow: 3px 0 7px rgba(0,0,0,0.55);-moz-box-shadow: 3px 0 7px rgba(0,0,0,0.55);  box-shadow: 3px 0 7px rgba(0,0,0,0.55);}
    .hamburgermenu ul li a{font-size: 0.15rem;color: #DBDBDB;text-decoration: none}
    .hamburgermenu ul li{height: 0.5rem;width: 100%;font-size: 0.18rem;color: #DBDBDB}
    .hamburgermenu ul li:first-child{margin-top: 0.5rem}
    .hamburgermenu ul{text-align: center;height: 100%}
    .show{-webkit-transform: translate3d(0,0,0);transform: translate3d(0,0,0)}
    .overlay.showright{display: block}
    .overlay{position: fixed;  z-index: 88;  background-color: rgba(0,0,0,0.5);  bottom: 0;  left: 0;height: 100%;width:100%;overflow: hidden;display:none;-webkit-transition:left 0.3s;transition:left 0.3s;}

  }

</style>



// WEBPACK FOOTER //
// head.vue?4110c4c8